import { PencilSquareIcon } from "@heroicons/react/24/outline";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function InterviewUpdateModal({ open, setOpen, applicant }) {
  const [interviewed, setInterviewed] = useState(false);
  const [interviewDate, setInterviewDate] = useState("");
  const token = localStorage.getItem("token");

  const navigate = useNavigate();

  const updateInterview = async (
    applicantId,
    interviewCompleted,
    interviewDate
  ) => {
    try {
      const response = await fetch(`/api/applicants/${applicantId}/interview`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: token,
        },
        body: JSON.stringify({
          interviewCompleted,
          interviewDate,
        }),
      });

      if (response.ok) {
        // const updatedApplicant = await response.json();
        // console.log("Interview updated:", updatedApplicant);
        setInterviewed(false);
        setInterviewDate("");
        setOpen(false);
        window.history.go(0);
      } else {
        console.error("Failed to update interview");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <Dialog open={open} onClose={setOpen} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
              <div className="sm:flex sm:items-start">
                <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                  <PencilSquareIcon
                    aria-hidden="true"
                    className="h-6 w-6 text-red-600"
                  />
                </div>
                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <DialogTitle
                    as="h3"
                    className="text-base font-semibold leading-6 text-gray-900"
                  >
                    interview status
                  </DialogTitle>
                  <div className="mt-2">
                    <div>
                      <label>Interview Done</label>
                      <input
                        className="w-5 h-5 ml-2"
                        type="checkbox"
                        checked={interviewed}
                        onClick={() => setInterviewed(!interviewed)}
                      />
                    </div>
                    <div>
                      <label>Interview date</label>
                      <input
                        className=" ml-2"
                        type="date"
                        onChange={(e) => setInterviewDate(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              <button
                type="button"
                onClick={() =>
                  updateInterview(applicant._id, interviewed, interviewDate)
                }
                className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
              >
                Update
              </button>
              <button
                type="button"
                data-autofocus
                onClick={() => {
                  setInterviewed(false);
                  setInterviewDate("");
                  setOpen(false);
                }}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
              >
                Cancel
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
